import { isSameDay, isThisYear, isToday, isYesterday } from 'date-fns';
import { i18n } from '@/i18n';
import { formatLocalizedDate } from '@/utils/dateHelpers';

// Tijd in een chatbubbel; de dag staat in de scheiding erboven.
export function formatMessageClock(timestamp: string): string {
    return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

// Dag van een bericht: Vandaag / Gisteren / "20 jul." (met jaar als het niet dit jaar is).
export function formatMessageDay(timestamp: string): string {
    const date = new Date(timestamp);
    // Lege of kapotte datum: niets tonen. formatLocalizedDate gooit anders en dan valt het scherm om.
    if (isNaN(date.getTime())) return '';
    if (isToday(date)) return i18n.global.t('Today');
    if (isYesterday(date)) return i18n.global.t('Yesterday');
    return formatShortDay(date);
}

// "20 jul.", with the year when it is not this year. Also the date on a check-in
// review card in the chat, where "Vandaag" would not fit the sentence.
export function formatShortDay(date: Date): string {
    const locale = i18n.global.locale.value === 'nl' ? 'nl' : 'en';
    return formatLocalizedDate(date, isThisYear(date) ? 'd MMM' : 'd MMM yyyy', locale);
}

// Chatlijst: tijd voor vandaag, anders de dag.
export function formatMessageTime(timestamp: string): string {
    return isToday(new Date(timestamp)) ? formatMessageClock(timestamp) : formatMessageDay(timestamp);
}

// Moet er boven dit bericht een dagscheiding? Berichten staan van oud naar nieuw.
export function startsNewDay(messages: { created_at: string }[], index: number): boolean {
    if (index === 0) return true;
    return !isSameDay(new Date(messages[index - 1].created_at), new Date(messages[index].created_at));
}

// Meldingen: "5 minuten geleden" / "3 uur geleden" binnen 24 uur, daarna de dag.
export function formatTimeAgo(timestamp: string): string {
    const t = i18n.global.t;
    // Niet onder nul: een serverklok die voorloopt gaf "-5 minuten geleden".
    const diffInHours = Math.max(0, (Date.now() - new Date(timestamp).getTime()) / (1000 * 60 * 60));
    if (isNaN(diffInHours)) return '';
    if (diffInHours >= 24) return formatMessageDay(timestamp);

    if (diffInHours < 1) {
        const minutes = Math.floor(diffInHours * 60);
        return `${minutes} ${t(minutes !== 1 ? 'minutes' : 'minute')} ${t('ago')}`;
    }
    const hours = Math.floor(diffInHours);
    return `${hours} ${t(hours !== 1 ? 'hours' : 'hour')} ${t('ago')}`;
}
